import useApiMutation from '@src/hooks/useApiMutation';
import { BulkCreateDevicesDto } from '@src/types/Device';

export default () => {
  const createBulkDevices = useApiMutation<BulkCreateDevicesDto, void>({
    apiPath: '/devices/bulk',
    method: 'POST',
    useV2API: true,
  });

  return {
    createBulkDevices,
  };
};
